import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  min-height: 400px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  padding-top: 24px;
  margin-top: auto;
`;
